
import * as handlebars_family from "../handlebars_family.js";

const TPL = handlebars_family.addTemplate("contact/input_birthdate",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<label> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"labels.birthday",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":8},"end":{"line":1,"column":36}}})) != null ? stack1 : "")
    + " <input type=\"date\" name=\"birthDate\" value=\""
    + container.escapeExpression((lookupProperty(helpers,"dateinput")||(depth0 && lookupProperty(depth0,"dateinput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"localBirthDate") : depth0),{"name":"dateinput","hash":{},"data":data,"loc":{"start":{"line":1,"column":80},"end":{"line":1,"column":108}}}))
    + "\" max=\""
    + container.escapeExpression((lookupProperty(helpers,"birthMaxDate")||(depth0 && lookupProperty(depth0,"birthMaxDate"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"",{"name":"birthMaxDate","hash":{},"data":data,"loc":{"start":{"line":1,"column":115},"end":{"line":1,"column":134}}}))
    + "\"/></label>";
},"useData":true});
export default TPL;